<template>
  <div>
    <div class="block__container block__container--compact">
      <step-header-component :headerText="headerText" :subHeaderText="subHeaderText"></step-header-component>
      <progress-bar
        :hideForwardNavigation="true"
        :hideBackwardNavigation="hideBackwardNavigation"
        :validationScope="validationScope"
        :progressBarValue=90>
      </progress-bar>
      <personal-details :validationScope="validationScope"></personal-details>
      <submit :validationScope="validationScope"></submit>
    </div>
    <div class="block--secondary block--center">
      <div class="block__container">
        <accordion></accordion>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import StepHeaderComponent from '../general/StepHeaderComponent.vue';
import CarouselComponent from '../general/CarouselComponent.vue';
import ProgressBarComponent from '../general/ProgressBarComponent.vue';
import VehicleCustomisationComponent from '../vehicle/VehicleCustomisationComponent.vue';
import SubmitButtonComponent from '../navigation/SubmitButtonComponent.vue';
import PricingDataComponent from '../pricing/PricingDataComponent.vue';
import TestimonialsComponent from '../general/TestimonialsComponent.vue';
import StartAgainComponent from '../navigation/StartAgainComponent.vue';
import AccordionComponent from '../general/AccordionComponent.vue';
import PersonalDetailsComponent from '../enquiry/PersonalDetailsComponent.vue';

@Component({
  components: {
  'step-header-component': StepHeaderComponent,
  'progress-bar': ProgressBarComponent,
  submit: SubmitButtonComponent,
  accordion: AccordionComponent,
  'personal-details': PersonalDetailsComponent
  }
  })

export default class PersonalDetailsStepComponent extends Vue {
  @Prop({ default: 'Your Details' })
  public headerText!: string;

  @Prop({ default: 'Final step before unlocking your pricing data' })
  public subHeaderText!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: false })
  public hideBackwardNavigation!: boolean;
}
</script>
